import React from "react";
import { generatePath, NavLink } from "react-router-dom";

import { useMainStore } from "@/contexts/Store";

import { ROUTES } from "../pages";
import ModuleTabs from "./ModuleTabs/ModuleTabs";

type AssessmentDetailsTabsProps = {
  assessmentId: string;
};

function AssessmentDetailsTabs(props: AssessmentDetailsTabsProps) {
  const mainStore = useMainStore();
  const { workspaceID } = mainStore.context;

  return (
    <ModuleTabs>
      <NavLink
        exact
        to={generatePath(ROUTES.ASSESSMENTS_DETAIL_PATH, {
          assessmentId: props.assessmentId,
          workspace_id: Number(workspaceID),
        })}
      >
        Assessment Details
      </NavLink>
      <NavLink
        exact
        to={generatePath(ROUTES.ASSESSMENTS_SCORING_PATH, {
          assessmentId: props.assessmentId,
          workspace_id: Number(workspaceID),
        })}
      >
        Scoring
      </NavLink>
    </ModuleTabs>
  );
}

export default AssessmentDetailsTabs;
